import { useMemo } from 'react';
import { CustomerItemStatus } from '../../../../store/features/customerUpdates/customerUpdatesSlice';
import { IconProps, StyledIconType } from '../../../Icons/StyledIconProps';
import { Button, mergeClasses, Tooltip } from '@fluentui/react-components';
import { useCustomerUpdatesTableActionStyles } from './CustomerUpdatesTableAction.styles';
import { useTranslation } from 'react-i18next';
import { customerItemStatusToIconType } from '../../../Icons/StyledIcon';

export interface CustomerUpdatesTableActionProps {
    status?: CustomerItemStatus;
    iconFactory?: (props: IconProps) => React.ReactElement;
    onClick?: () => void;
}

const CustomerUpdatesTableAction: React.FC<CustomerUpdatesTableActionProps> = ({
    status,
    iconFactory,
    onClick,
}) => {
    const styles = useCustomerUpdatesTableActionStyles();
    const { t } = useTranslation();

    const { hide, iconType } = useMemo<{
        hide?: boolean;
        iconType?: StyledIconType;
    }>(
        () =>
            status
                ? { iconType: customerItemStatusToIconType(status) }
                : { hide: true },
        [status]
    );

    return (
        <Tooltip
            content={t('Button_ViewDetails_Tooltip')!}
            relationship="label"
            withArrow
        >
            <Button
                className={mergeClasses(
                    styles.action,
                    hide ? styles.hiddenAction : undefined
                )}
                appearance="transparent"
                icon={
                    iconFactory &&
                    iconFactory({ type: iconType, interactive: true })
                }
                onClick={() => onClick && onClick()}
                disabled={hide}
            />
        </Tooltip>
    );
};

export default CustomerUpdatesTableAction;
